import { render, staticRenderFns } from "./SquareMeters.vue?vue&type=template&id=629a1e61&lang=pug"
import script from "./SquareMeters.vue?vue&type=script&lang=js"
export * from "./SquareMeters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports